import React, { useRef } from "react";
import { FiMail, FiMapPin, FiPhoneCall } from "react-icons/fi";
import Layout from "../../layout/Layout";
import Head from "../Head";
import emailjs from "@emailjs/browser";

const ContactUs = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_aykq60s",
        "template_6ql3tog",
        form.current,
        "_RAmrKX3RzOszYWU6"
      )
      .then(
        (result) => {
          alert((result.text = "message sent successfully"));
        },
        (error) => {
          console.log(error.text);
        }
      );
    e.target.reset();
  };

  const ContactDetails = [
    {
      id: 1,
      title: "Email Us",
      info: "Lorem ipsum, dolor sit amet consectetur",
      icon: FiMail,
      contact: "asogwachinedu51@gmail.com",
    },

    {
      id: 2,
      title: "Call Us",
      info: "Lorem ipsum, dolor sit amet consectetur",
      icon: FiPhoneCall,
      contact: "+234 9033 0606 78",
    },

    {
      id: 3,
      title: "Location",
      info: "Lorem ipsum, dolor sit amet consectetur",
      icon: FiMapPin,
      contact: "No: Eugene street Aroma, Awka Anambra State",
    },
  ];
  return (
    <div>
      <Layout>
        <div className="min-height-screen container mx-auto px-2 my-6">
          <Head title="Contact Us" />
          <div className="grid mg:grid-cols-2 gap-6 lg:my-20 my-10 lg:grid-cols-3 xl:gap-8">
            {ContactDetails.map((item) => (
              <div
                key={item.id}
                className="border border-border flex-colo p-10 bg-dry rounded-lg text-center "
              >
                <span className="flex-colo w-20 h-20 mb-4 rounded-full bg-main text-subMain text-2xl ">
                  <item.icon />
                </span>
                <h5 className="text-xl font-semibold mb-2">{item.title}</h5>
                <p className="mb-0 text-sm text-text leading-7">
                  <a href={`mailto: ${item.contact}`} className="text-red-600">
                    {item.contact}
                  </a>{" "}
                  <br />
                  {item.info}
                </p>
              </div>
            ))}
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 mx-4 md:mx-4">
          <div className=" bg-dry w-full rounded-xl mx-auto mb-4">
            <form ref={form} onSubmit={sendEmail}>
              <div className="row pt-5 mx-auto w-full text-black">
                <div className="col-8 form-group mx-auto">
                  <input
                    type="text"
                    className="w-full"
                    placeholder="Name"
                    name="user_name"
                  />
                </div>

                <div className="col-8 form-group pt-2 ">
                  <input
                    type="email"
                    className="w-full"
                    placeholder="Email Address"
                    name="user_email"
                  />
                </div>

                <div className="col-8 form-group pt-2 mx-auto">
                  <input
                    type="text"
                    className="w-full"
                    placeholder="Subject"
                    name="subject"
                  />
                </div>

                <div className="col-8 form-group pt-2 mx-auto">
                  <textarea
                    className="w-full"
                    id=""
                    cols="34"
                    rows="8"
                    placeholder="Your message"
                    name="message"
                  />
                </div>
                <div className="col-8 pt-3 mx-auto">
                  <input
                    type="submit"
                    className="mx-auto w-full h-10 mb-2 p-auto rounded-md bg-red-600 text-white font-semibold cursor-pointer hover:bg-transparent hover:text-white"
                    value="Send Message"
                  />
                </div>
              </div>
            </form>
          </div>

          <div className="mx-auto">
            <img
              src="../images/contact-us.png"
              alt="contact us"
              className="w-full mb-8"
            />
          </div>
        </div>
      </Layout>
    </div>
  );
};

export default ContactUs;
